import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, output, signal, viewChild} from "@angular/core";
import {BzSearchInput} from "@bringoz/ui";
import {TranslateService} from "@ngx-translate/core";
import {PANEL_DATA} from "../../services/panel.service";
import {
  TableColumnOption,
  TableColumnPickerData,
  TableColumnSection,
  TableColumnToggle
} from "../../models/table-column-option.model";

require('./table-column-picker.scss');
@Component({
  standalone: false,
  selector: 'app-table-column-picker',
  templateUrl: './table-column-picker.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'(document:keydown.escape)': 'close()'}
})
export class TableColumnPickerComponent implements AfterViewInit {
  // Subscribed to by PanelService, which closes the panel with the emitted value
  readonly onClose = output<TableColumnToggle | undefined>();

  readonly data: TableColumnPickerData = inject(PANEL_DATA);
  readonly filteredSections = signal<TableColumnSection[]>(this.data.sections);

  private readonly searchInput = viewChild.required(BzSearchInput, {read: ElementRef});
  private readonly translateService = inject(TranslateService);

  ngAfterViewInit() {
    // preventScroll: the overlay is attached before it's positioned under the "+"
    this.searchInput().nativeElement.querySelector('input')?.focus({preventScroll: true});
  }

  onQueryChange(query: string) {
    const lowerQuery = (query || '').toLowerCase();
    this.filteredSections.set(this.data.sections
      .map(section => ({...section, options: section.options.filter(option => this.translateService.instant(option.labelKey).toLowerCase().includes(lowerQuery))}))
      .filter(section => section.options.length));
  }

  insert(option: TableColumnOption) {
    this.close({option, enabled: true});
  }

  hide() {
    this.close({option: this.data.currentColumn, enabled: false});
  }

  close(toggle?: TableColumnToggle) {
    this.onClose.emit(toggle);
  }
}
